import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    url: String,
    batchId: Number,
    claimId: Number
  }

  update(event) {
    const step = event.target.value;

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      },
      body: new URLSearchParams({
        batch_id: this.batchIdValue,
        claim_id: this.claimIdValue,
        step: step
      })
    })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html));
  }
}
